import { render, staticRenderFns } from "./Bbsinfo.vue?vue&type=template&id=a663bade&"
import script from "./Bbsinfo.vue?vue&type=script&lang=js&"
export * from "./Bbsinfo.vue?vue&type=script&lang=js&"
import style0 from "./Bbsinfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports